import { ACTIONS } from '../../config/permissions-config';

export const PermissionActionsEnum = ACTIONS;
export type PermissionActionsEnum = typeof ACTIONS[keyof typeof ACTIONS];